import { useDispatch } from "react-redux";
import { CarePlanGrid } from "./CarePlanGrid";
import { useEffect } from "react";
import { setPageTitle } from "../../store/slices/pageTitleSlice";

export const CarePlans = () => {

  const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setPageTitle('Care Plans | Spire360'));
    }, []);

  return (
    <>
      <CarePlanGrid breadcrumbs={true}></CarePlanGrid>
    </>
  );
};
